<template lang="pug">
div
  el-row
    el-col(:sm="20")
      h2
        span Контрагенти
        el-button(type="success", icon="el-icon-plus", @click="$router.push(url + '/new')") Добави

    el-col(:sm="4")
      el-button.fr(type="primary", :disabled="false", @click="exportData") Експорт

  el-form(:model="filters")
    el-row
      el-col(:sm="4")
        el-form-item
          el-input(v-model="filters.name", placeholder="Име")
      el-col(:sm="4")
        el-form-item
          el-select(v-model="filters.type", clearable, placeholder="Всички")
            el-option(v-for="(type, value) in consts.contragentType", :label="type.title", :value="value", :key="value")
      el-col(:sm="4")
        el-form-item
          el-select(v-model="filters.subscription", clearable, placeholder="Абонамент")
            el-option(label="Абонати", value="1")
            el-option(label="Неабонати", value="2")
      el-col(:sm="2")
        el-form-item
          el-select(v-model="filters.year", clearable, placeholder="Година", :disabled="filters.subscription != 1")
            el-option(v-for="year in common.getYearsOptions(true)", :label="year.title", :value="year.id", :key="year.id")
      el-col(:sm="3")
        el-form-item
          el-select(v-model="filters.subscriptionType", clearable, placeholder="Вид абонамент", :disabled="filters.subscription != 1 || !filters.year")
            el-option(v-for="(type, value) in consts.subscriptionType", :label="type.title", :value="value", :key="value")
      el-col(:sm="3")
        el-form-item
          el-select(v-model="filters.subscriptionVariant", clearable, placeholder="Вариант абонамент", :disabled="filters.subscription != 1 || !filters.year")
            el-option(v-for="(variant, value) in consts.subscriptionVariant", :label="variant.title", :value="value", :key="value")
      el-col(:sm="2")
        el-select(v-model="filters.paymentStatus", placeholder="Платено/Неплатено", clearable, :disabled="filters.subscription != 1 || !filters.year")
          el-option(v-for="(status, value) in consts.paymentStatus", :label="status.title", :value="parseInt(value)", :key="value")
      el-col(:sm="2")
        el-form-item
          el-button(@click="clearFilters") Изчисти

  datatable(ref="datatable", :url="apiUrl", :filters="filters")
    el-table-column(prop="name", label="Контрагент", sortable="custom", :sort-method="x => {}")
      template(slot-scope="scope")
        small(style="width:40px; display:inline-block") {{ scope.row.degree ? consts.contragentDegree[scope.row.degree].title : '' }}
        router-link(:to="url + '/' + scope.row.id") {{ scope.row.name }}
    el-table-column(label="Абонамент", width="180")
      template(slot-scope="scope")
        div(v-html="renderSubscriptions(scope.row)")
    el-table-column(label="Детайли", width="180")
      template(slot-scope="scope")
        div(v-html="renderDetails(scope.row)")
    el-table-column(prop="phone", label="Тел.", width="150")
    el-table-column(prop="phone2", label="Тел.", width="150")
    el-table-column(prop="email", label="Ел. поща", width="180")
    el-table-column(prop="created_at", label="Добавен", :formatter="dateFormatter", sortable="custom", :sort-method="x => {}", width="110")

</template>

<script>
import Datatable from './Datatable.vue'
import listMixin from '../mixins/listMixin.js'

export default {
  name: 'ContragentList',
  mixins: [listMixin],
  data () {
    return {
      url: '/contragents',
      apiUrl: '/contragents',
      filters: {
        name: '',
        type: '',
        subscription: '',
        year: '',
        subscriptionType: '',
        subscriptionVariant: '',
        paymentStatus: ''
      }
    }
  },
  methods: {
    exportData () {
      const params = Object.keys(this.filters).map(f => f + '=' + this.filters[f])
      window.open(`${this.$baseURL}contragents?${params.join('&')}&format=xls&token=${this.$auth.token()}`)
    },
    renderSubscriptions (row) {
      var html = []
      var currentYear = new Date().getFullYear()

      JSON.parse(JSON.stringify(row.subscriptions)).sort((a, b) => {return b.year - a.year}).forEach(s => {
        var subscriptionText = s.year + ' - '
        if (s.type) subscriptionText += this.consts.subscriptionType[s.type].short
        if (s.variant) subscriptionText += ', ' + this.consts.subscriptionVariant[s.variant].short
        if (s.year >= currentYear){
          html.push('<strong>' + subscriptionText + '</strong>')
        }else{
          html.push('<small class="text-muted">' + subscriptionText + '</small>')
        }
      })

      return html.join('<br/>')
    },
    renderDetails (row) {
      var html = []
      html.push('<small>')
      html.push(this.consts.contragentType[row.type].title)

      switch(row.type){
        case 10:
          if(row.specialty) html[html.length-1] = row.specialty // html.push(' ('+row.specialty+')')
          if(row.clinic) html.push(' в '+row.clinic)
        break
        case 20:
          html.push(' в '+row.laboratory)
        break
        case 30:
        case 40:
          if(row.position) html.push(' ('+row.position+')')
          if(row.companyName) html.push(' в '+row.companyName)
        break
      }
      html.push('</small>')
      return html.join('')
    }
  },
  components: {
    Datatable
  }
}
</script>